import React, { Component } from 'react';
import { Translate } from '$common';



export default class Information extends Component {
  static type = 'information';
  static elementName = Translate.get('information');
  static icon = 'bullhorn';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/information.js